// extracted by mini-css-extract-plugin
module.exports = {"dialog-layout":"dialog-layout_dialog-layout__QKPEI","show":"dialog-layout_show__OoyzX","content":"dialog-layout_content__aHcgt","close":"dialog-layout_close___lfr0"};